<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">直播管理</a>
          <i>></i>
          <a href="javascript:;" @click="goHerf()">班级管理</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">{{liveProjectName}}-详情</a>
        </span>
      </div>
      <div class="framePage-body framePage-tabs">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabChange">
          <el-tab-pane label="基本信息" name="first">
            <editLiveClass ref="first" />
          </el-tab-pane>
          <el-tab-pane label="直播课程" name="second">
            <liveClassCourse ref="second" />
          </el-tab-pane>
          <el-tab-pane label="学员列表" name="three">
            <liveStudentList ref="three" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import editLiveClass from "@/views/liveBroadcastManagement/editLiveClass";
import liveClassCourse from "@/views/liveBroadcastManagement/liveClassCourse";
import liveStudentList from "@/views/liveBroadcastManagement/liveStudentList";
import { mapGetters } from "vuex";
export default {
  name: "ClassdetailsList",
  components: {
    editLiveClass,
    liveClassCourse,
    liveStudentList,
  },
  mixins: [List],
  data() {
    return {
      activeName: "",
      liveProjectName: "",
    };
  },
  mounted() {},
  watch: {
    activeName: function(nval, oval) {
      if (nval && nval != "first") {
        this.$refs[nval].getData();
        if (nval == "three") {
          this.$refs.three.openOnce();
      }
      }
    }
  },
  computed: {
    ...mapGetters({
      userJson: "getUser"
    })
  },
  methods: {
    init() {
      this.liveProjectName = sessionStorage.getItem("liveProjectName");
      this.projectId = sessionStorage.getItem("projectId");
      this.projectSource = sessionStorage.getItem("projectSource");
      const query = this.$route.query;
      if (query.active) {
        this.activeName = query.active;
      }
    },
    tabChange(tab) {
      this.activeName = tab.name;
      this.$refs[tab.name].userName = "";
      this.$refs[tab.name].idcard = "";
      this.$refs[tab.name].mobile = "";
      this.$refs[tab.name].completeState = "";
      // if (tab.name == "three") {
      //   this.$refs.three.openOnce();
      // }
    },
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName }
      });
    },
    goHerf() {
          this.$router.push({
            name: "liveClassManagement",
            params: {
              refresh: true,
              isAdd: false
            }
          });
    }
  }
};
</script>
<style lang="less" scoped>
.framePage-tabs {
  flex: 1;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  padding: 1rem 0.675rem;
  box-sizing: border-box;
}
#pane-first {
  display: flex;
  flex: 1;
  overflow: hidden;
}
</style>
<style lang="less">
.framePage-tabs {
  .el-tabs {
    width: 100%;
  }
  .el-tabs__content {
    overflow-y: auto;
  }
}
</style>
